import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Features from './components/Features/Features';
import BetaAccess from './components/BetaAccess/BetaAccess';
import FeatureGrid from './components/FeatureGrid/FeatureGrid';
import Footer from './components/Footer/Footer';
import ReactGA from 'react-ga4';

const App = () => {
  ReactGA.initialize('G-3DP480Y66R');

  return (
    <div className="app">
      <Header />
      <Hero />
      <BetaAccess />
      <Features />
      <FeatureGrid />
      <Footer />
    </div>
  );
};

export default App;